import React from 'react';
import FloatingChatWidget from './components/FloatingChatWidget';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="hero-section">
          <h1>Welcome to KaireAI</h1>
          <p>Your smart health companion for aging in place</p>
        </div>
      </header>
      
      <main className="main-content">
        <div className="features-grid">
          <div className="feature-card">
            <h3>24/7 Health Monitoring</h3>
            <p>Smart sensors track your wellbeing around the clock</p>
          </div>
          <div className="feature-card">
            <h3>Family Dashboard</h3>
            <p>Keep loved ones connected and informed</p>
          </div>
          <div className="feature-card">
            <h3>Emergency Response</h3>
            <p>Instant alerts when you need help most</p>
          </div>
        </div>
      </main>

      <FloatingChatWidget position="bottom-right" />
    </div>
  );
}

export default App;